import React, { useState, useContext, useEffect } from "react";
import { Col, Container, Row } from 'react-bootstrap';
import './CorporateActOption.css';
import { useNavigate } from "react-router-dom";
import URLstateContext from "../../../provider/CommonContext";


function MarketEquity(props) {
    let getOptionCorp = props.optionCorp;
    const { BaseURL } = useContext(URLstateContext);
    const [optionInfoA, setOptionInfoA] = useState('');
    let navigate = useNavigate();

    useEffect(() => {
        if (optionInfoA === "Daily Announcements") {
            navigate("/CorporateAction/Daily-Announcements");
        }
        if (optionInfoA === "Board Meetings") {
            navigate("/CorporateAction/Board-Meetings");
        }
        if (optionInfoA === "Book Closure") {
            navigate("/CorporateAction/Book-Closure");
        }
        if (optionInfoA === "BuyBack List") {
            navigate("/CorporateAction/BuyBack-List");
        }
        if (optionInfoA === "Bonus") {
            navigate("/CorporateAction/Bonus");
        }
        if (optionInfoA === "Dividend") {
            navigate("/CorporateAction/Dividend");
        }
        if (optionInfoA === "Rights") {
            navigate("/CorporateAction/Rights");
        }
        if (optionInfoA === "De-listed shares") {
            navigate("/CorporateAction/De-listed-Shares");
        }
        if (optionInfoA === "Market Turnover") {
            navigate("/CorporateAction/Market-Turnover");
        }
        if (optionInfoA === "Change of Name") {
            navigate("/CorporateAction/Change-Name");
        }
        if (optionInfoA === "Split of Face Value") {
            navigate("/CorporateAction/Split-Face-Value");
        }
        if (optionInfoA === "Overview") {
            navigate("/market/stocks");
        }

    }, [optionInfoA]);


    return (
        <>
            <Container>
                <Row>
                    <Col sm={12}>
                        <section className='market-loser-scCorp'>
                            <div className='market-inner'>
                                <div className='market-select'>
                                    <select value={getOptionCorp} onChange={(event) => { setOptionInfoA(event.target.value) }}>
                                        <option value={"Overview"}>Overview</option>
                                        <option value={"Daily Announcements"}>Daily Announcements</option>
                                        <option value={"Board Meetings"}>Board Meetings</option>
                                        <option value={"Book Closure"}>Book Closure</option>
                                        <option value={"Bonus"}>Bonus</option>
                                        <option value={"BuyBack List"}>BuyBack List</option>
                                        <option value={"Dividend"}>Dividend</option>
                                        <option value={"Rights"}>Rights</option>
                                        <option value={"De-listed shares"}>De-listed shares</option>
                                        <option value={"Market Turnover"}>Market Turnover</option>
                                        <option value={"Change of Name"}>Change of Name</option>
                                        <option value={"Split of Face Value"}>Split of Face Value</option>
                                    </select>
                                </div>
                            </div>
                        </section>
                    </Col>
                </Row>
            </Container>
        </>
    );
}

export default MarketEquity;